export default class ScrollNavbar {

    static init() {
        const navbar = document.querySelector('#menu');
        if (navbar) {
            const navbarHeight = navbar.clientHeight;
            let lastScrollY = -1;

            const scrollToggler = () => {
                if (window.scrollY > navbarHeight && lastScrollY - window.scrollY <= 0) {
                    if (! navbar.classList.contains('hide')) {
                        navbar.classList.add('hide');
                    }
                }

                if (navbar.classList.contains('hide') && lastScrollY - window.scrollY > 0) {
                    navbar.classList.remove('hide');
                }

                lastScrollY = window.scrollY;
            };

            window.addEventListener('scroll', scrollToggler);
        }
    }
}
